import { ButtonBase } from '@fukku/button/Base/ButtonBase'
import textActionM from '@fukku/styles/texts/textActionM.module.css'
import { cx } from 'utils/cx'
import styles from '../OverlayButton.module.css'
import type { OverlayButtonTextProps } from '../types'

export const TextOnlyOverlayButton = (props: OverlayButtonTextProps) => {
	const { className, children, variant, ...rest } = props

	return (
		<ButtonBase
			{...rest}
			className={cx(
				className,
				styles.overlayButton,
				styles[variant],
				textActionM.className
			)}
		>
			<span className={styles.content}>{children}</span>
		</ButtonBase>
	)
}
